import { useApp } from '@/store/AppContext'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatCurrency } from '@/lib/pricing'
import { LogIn, LogOut, History, User } from 'lucide-react'

export function ActivityLog() {
  const { tickets, payments } = useApp()

  const entries = tickets.map((t) => ({
    id: `in-${t.id}`,
    type: 'checkin',
    plate: t.plate,
    date: t.checkInAt,
    operator: t.operatorName || 'Sistema',
  }))

  const exits = tickets
    .filter((t) => t.status === 'closed')
    .map((t) => {
      const payment = payments.find((p) => p.ticketId === t.id)
      return {
        id: `out-${t.id}`,
        type: 'checkout',
        plate: t.plate,
        date: t.checkOutAt!,
        operator: t.operatorName || 'Sistema',
        amount: payment?.amount || 0,
      }
    })

  const logs = [...entries, ...exits]
    .sort((a, b) => b.date.getTime() - a.date.getTime())
    .slice(0, 10)

  return (
    <Card className="shadow-sm border-none md:border-solid">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <History className="h-5 w-5 text-muted-foreground" />
          Últimas 10 Ações
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y">
          {logs.length === 0 ? (
            <div className="p-6 text-center text-muted-foreground">
              Nenhuma atividade registrada hoje.
            </div>
          ) : (
            logs.map((log) => (
              <div
                key={log.id}
                className="flex items-center justify-between p-4 hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`p-2 rounded-full flex-shrink-0 ${log.type === 'checkin' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'}`}
                  >
                    {log.type === 'checkin' ? (
                      <LogIn className="h-4 w-4" />
                    ) : (
                      <LogOut className="h-4 w-4" />
                    )}
                  </div>
                  <div>
                    <div className="font-bold tracking-wide">{log.plate}</div>
                    <div className="text-xs text-muted-foreground flex items-center gap-1">
                      <User className="h-3 w-3" /> {log.operator} •{' '}
                      {log.date.toLocaleTimeString('pt-BR', {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>
                  </div>
                </div>
                {log.type === 'checkout' && (
                  <div className="font-medium text-sm">
                    {formatCurrency(log.amount!)}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  )
}
